// DEVN3-760: a sessão vale 48h a partir do login, com ou sem uso. O token enviado à API é o
// idToken do Firebase (vale só 1h), então ele é renovado pelo SDK antes de cada chamada; o
// limite da sessão é controlado aqui, pela hora do login guardada no localStorage.
export const DURACAO_SESSAO_MS = 48 * 60 * 60 * 1000;

export function sessaoExpirada(inicio: number | null, agora: number = Date.now()): boolean {
    if (inicio === null) return false;
    return agora - inicio >= DURACAO_SESSAO_MS;
}

// Renova com folga para o token nunca chegar vencido à API (e o usuário nunca ver o login).
export const ANTECEDENCIA_RENOVACAO_MS = 10 * 60 * 1000;

// Lê o "exp" (epoch ms) do payload do JWT, sem validar assinatura — só para agendar a renovação.
export function expiracaoDoToken(token: string | null): number | null {
    const payload = token?.split('.')[1];
    if (!payload) return null;

    try {
        const base64 = payload.replace(/-/g, '+').replace(/_/g, '/').padEnd(Math.ceil(payload.length / 4) * 4, '=');
        const exp = JSON.parse(atob(base64)).exp;
        return typeof exp === 'number' ? exp * 1000 : null;
    } catch {
        return null;
    }
}

// Quanto esperar até renovar; 0 = renovar já (token sem exp legível, perto de vencer ou vencido).
export function atrasoRenovacao(token: string | null, agora: number = Date.now()): number {
    const exp = expiracaoDoToken(token);
    if (exp === null) return 0;
    return Math.max(0, exp - ANTECEDENCIA_RENOVACAO_MS - agora);
}

interface UsuarioFirebase {
    getIdToken(forceRefresh?: boolean): Promise<string>;
}

// getIdToken() devolve o token em cache ou, faltando menos de 5 min para vencer, renova pelo
// refresh token. Sem usuário do Firebase restaurado (IndexedDB limpo, por exemplo) ou com falha
// na renovação, segue com o token guardado — se ele já venceu, a API responde 401 e o
// interceptor leva ao login, como antes.
export async function obterTokenAtualizado(
    usuarioFirebase: UsuarioFirebase | null,
    tokenGuardado: string
): Promise<string> {
    if (!usuarioFirebase) return tokenGuardado;

    try {
        return await usuarioFirebase.getIdToken();
    } catch {
        return tokenGuardado;
    }
}
